"use client";

import { Search, X } from "lucide-react";
import { Input } from "../ui/input";
import { useCallback, useEffect, useRef, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";

export default function SearchBlogListings() {
  const searchParams = useSearchParams();
  const [userSearchQuery, setSearchQuery] = useState(
    searchParams.get("q") ?? "",
  );
  const router = useRouter();
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const buildHref = useCallback(
    (query: string) => {
      const params = new URLSearchParams();
      const category = searchParams.get("category");
      if (category) params.set("category", category);
      if (query.trim()) params.set("q", query.trim());
      const qs = params.toString();
      return qs ? `/blog?${qs}` : "/blog";
    },
    [searchParams],
  );

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const currentQ = searchParams.get("q") ?? "";
      if (userSearchQuery.trim() !== currentQ) {
        router.push(buildHref(userSearchQuery));
      }
    }, 300);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [userSearchQuery, searchParams, router, buildHref]);

  function handleClear() {
    setSearchQuery("");
    router.push(buildHref(""));
  }

  return (
    <form
      className="relative w-full md:max-w-sm"
      onSubmit={(e) => {
        e.preventDefault();
        if (debounceRef.current) clearTimeout(debounceRef.current);
        router.push(buildHref(userSearchQuery));
      }}
    >
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="text"
        aria-label="Pretraži blog"
        placeholder="Pretraži blog..."
        value={userSearchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-9 pr-9"
      />
      {userSearchQuery && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-sm p-1 text-muted-foreground hover:text-foreground"
          title="Očisti pretragu"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </form>
  );
}
